<h2>{{ 'ACCOUNTS_MODULE.userTasks.title' | translate }}
  <span *ngIf="tasks">({{ tasks.length }})</span>
</h2>
<div class="tasks">
<div ngbAccordion
  #accordion = "ngbAccordion"
  [animation]="false"
  *ngIf="totalTasks > 0; else NO_DATA"
  [closeOthers]="true"
  (show)="onPanelToggle($event)">

  @for (task of tasks; track task.id) {
    <div [ngbAccordionItem]="task.id.toString()">
      <h4 ngbAccordionHeader class="accordion-button">
        <div ngbAccordionToggle role="button" class="btn btn-link custom-header" id="{{task.id + '-toggle'}}">
          <div>
            <span class="mr-1">{{ 'ACCOUNTS_MODULE.userTasks.actionRequiredLabel' | translate }}:</span>
            <span [innerHTML]="task.taskTypeTranslated"></span>
          </div>
          <div>
            <fa-icon [icon]="['far', task.isRead ? 'envelope-open' : 'envelope']"></fa-icon>
          </div>
        </div>
      </h4>

      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <app-task-details [task]="task" [showAction]="true"></app-task-details>
          </ng-template>
        </div>
      </div>
    </div>
  }
</div>
  <ng-template #NO_DATA>
    <ng-container *ngIf="totalTasks === 0; else LOADING">
      <div>{{ 'COMMON.custom_messages.noItems' | translate }}</div>
    </ng-container>
    <ng-template #LOADING>
      <div>{{ 'COMMON.custom_messages.pleaseWait' | translate }}</div>
    </ng-template>
  </ng-template>
</div>

<p class="text-center mt-4" *ngIf="tasks">
  <span
   [translate]="'ACCOUNTS_MODULE.dashboard.recordsInPanel'"
   [translateParams]="{
      current: tasks.length,
      total: totalTasks
   }"></span>&nbsp;

  <ng-container *ngIf="tasks.length < totalTasks; else ALL_ITEMS">
    <a href="#" (click)="viewNumberOfItems($event, totalTasks)">{{ 'COMMON.custom_messages.viewAll' | translate }}</a>
  </ng-container>
  <ng-template #ALL_ITEMS>
    <a href="#" (click)="viewNumberOfItems($event)">{{ 'COMMON.custom_messages.viewLess' | translate }}</a>
  </ng-template>

</p>
